import { Component, Input, OnChanges } from "@angular/core";
import { ApiService } from "src/app/api.service";
import { APIResults } from "src/app/sharedinterfaces";

@Component({
	selector: "app-manage-recalculate",
	templateUrl: "./manage-recalculate.component.html",
	styleUrls: ["./manage-recalculate.component.scss"]
})
export class ManageRecalculateComponent implements OnChanges {
	@Input()
	asset: APIResults.Asset;

	public hiStatus: string;
	public hiProgress: number;

	constructor(private api: ApiService) { }

	ngOnChanges(): void {
		this.hiProgress = undefined;
		this.hiStatus = undefined;
	}

	public async GenerateHIs() {
		const result = await this.api.GenerateHIs(this.asset.asset_id);
		const taskId = result.task;
		await new Promise<void>((resolve, reject) => {
			this.PollToCompletion(taskId, resolve, reject);
		});
	}

	public async RecalculateStates() {
		await this.api.RecalculateAssetStates(this.asset.asset_id);
	}

	private async PollToCompletion(taskId: number, resolve: () => void, reject: (err: any) => void) {
		try {
			const state = await this.api.GetTaskStatus(taskId);
			this.hiStatus = state.status;
			this.hiProgress = state.progress;
			if (state.complete) {
				resolve();
			} else {
				setTimeout(() => {
					this.PollToCompletion(taskId, resolve, reject);
				}, 1000);
			}
		} catch (err) {
			reject(err);
		}
	}
}
